





































































import { UiIconButton } from '../keen-ui';

import { DeviceEnum } from '../../enums';

export default {
  name: 'synonyms-values',
  components: {
    UiIconButton
  },
  computed: {
    containerGridClass: function (): string {
      return (this.hasSynonyms && this.hasHyponyms) ? 'epb-grid-col-md-4' : 'epb-grid-col-md-12';
    },
    hasSynonyms: function (): boolean {
      return !!this.synonyms;
    },
    hasHyponyms: function (): boolean {
      return !!this.hyponyms;
    }
  },
  props: {
    synonyms: Array,
    hyponyms: Array
  },
  data: function () {
    return {
      DeviceEnum,
      messages: this.$epb.messages.tools.synonyms
    };
  },
  methods: {
    removeValue: function (values: any[], value: string) {
      values.splice(values.indexOf(value), 1);
    }
  }
};

